var imgFile = [],
imgSrc = [],
imgName = [];
$(function() {
    $(".content-img-list").off("click").on("click", ".content-img-list-item a .gcllajitong",
    function() {
        var t = $(this).parent().parent().parent().index(),
        e = $("#image_all").val().split(",");
        imgSrc.splice(t, 1),
        imgFile.splice(t, 1),
        imgName.splice(t, 1),
        e.splice(t, 1);
        var i = e.join(",");
        $("#image_all").val(i);
        var a = ".content-img-list";
        addNewContent(a),
        imgSrc.length < 4 && $(".content-img .file").show(),
        $(".upload_number").text(imgSrc.length);
      
        $(".loading_class").hide()
    }),
    $(".content-img-list").on("click", ".content-img-list-item a .gclfangda",
    function() {
        var t = $(this).parent().parent().parent().index();
        $(".modal-content").html("");
        var e = $(".modal-content").html();
        $(".modal-content").html(e + '<div class="show"><img src="' + imgSrc[t] + '" alt=""><div>')
    })
}),
$(".upload").on("change",
function(t) {
    var e = this.files[0].size;
    if (e > 1024 * 1024 * 10) return alert("The uploaded image cannot exceed 10MB, Note: large files take longer time to upload.");
    if (this.files[0].type != "image/png" && this.files[0].type != "image/jpeg" && this.files[0].type != "image/gif") return alert("The image upload format is incorrect, Please use PDF, JPG, or PNG format.");
    for (var i = ".content-img-list",
    a = this.files,
    n = 0; n < a.length; n++) {
        var r = getObjectURL(a[n]);
        imgName.push(a[n].name),
        imgSrc.push(r),
        imgFile.push(a[n])
    }
    addNewContent(i),
    this.value = null;
    var s = new FormData;
    $.each(imgFile,
    function(l, o) {
        s.append("photo[]", o)
    }),
    $("#image_all").val("uploading"),
    $.ajax({
        url: "https://api.nextpair.com/api/upload/upload_next_pair",
        type: "POST",
        data: s,
        async: !0,
        cache: !1,
        contentType: !1,
        processData: !1,
        dataType: "json",
        success: function(l) {
            if (l.code == 200) {
                var number = 100;
                $("#normalslide2 .pro-bar-color").css("width",number+"%");
                $("#normalslide2 .pro-bar-title").text(number+"%");
                $("#normalslide2 .pro-bar-title").addClass('in-progress');
                var o = l.file.length;
                $(".upload_number").text(o);
                var c = l.file.join(",");
                $("#image_all").val(c),
                $(".loading_class").hide()
            }
        }
    })
}),
// $("#btn-submit-upload").on("click",
// function() {
//     var t = new FormData;
//     $.each(imgFile,
//     function(e, i) {
//         t.append("photo[]", i)
//     }),
//     $.ajax({
//         url: "https://api.nextpair.com/api/upload/upload",
//         type: "POST",
//         data: t,
//         async: !0,
//         cache: !1,
//         contentType: !1,
//         processData: !1,
//         dataType: "json",
//         success: function(e) {
//             console.log(e)
//         }
//     })
// });
function removeImg(t, e) {
    imgSrc.splice(e, 1),
    imgFile.splice(e, 1),
    imgName.splice(e, 1);
    var i = ".content-img-list";
    addNewContent(i)
}
function addNewContent(t) {
    $(t).html(""),
    $(".product-form__item").addClass("cont2");
    for (var e = 0; e < imgSrc.length; e++) {
        var i = $(t).html();
        $(t).html(i + '<li class="content-img-list-item"><img src="' + imgSrc[e] + '" alt=""><div class="loading_class"><svg version="1.1" id="L2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><circle fill="none" stroke="#2c2c2c" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="48"/><line fill="none" stroke-linecap="round" stroke="#2c2c2c" stroke-width="4" stroke-miterlimit="10" x1="50" y1="50" x2="85" y2="50.5"><animateTransform attributeName="transform" dur="2s" type="rotate" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></line><line fill="none" stroke-linecap="round" stroke="#2c2c2c" stroke-width="4" stroke-miterlimit="10" x1="50" y1="50" x2="49.5" y2="74"><animateTransform attributeName="transform" dur="15s" type="rotate" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></line></svg></div><div class="hide1"><a index="' + e + '" class="delete-btn"><i class="gcl gcllajitong"><svg t="1664164859846" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2552" width="16" height="16"><path d="M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m0-572.330667L300.629333 240.213333a42.538667 42.538667 0 0 0-60.16 0.213334 42.410667 42.410667 0 0 0-0.213333 60.16L451.669333 512 240.213333 723.370667a42.538667 42.538667 0 0 0 0.213334 60.16 42.410667 42.410667 0 0 0 60.16 0.213333L512 572.330667l211.370667 211.413333a42.538667 42.538667 0 0 0 60.16-0.213333 42.410667 42.410667 0 0 0 0.213333-60.16L572.330667 512l211.413333-211.370667a42.538667 42.538667 0 0 0-0.213333-60.16 42.410667 42.410667 0 0 0-60.16-0.213333L512 451.669333z" fill="#3D3D3D" p-id="2553"></path></svg></i></a></div></li>')
    }
    $(".loading_class").show()
}
function getObjectURL(t) {
    var e = null;
    return window.createObjectURL != null ? e = window.createObjectURL(t) : window.URL != null ? e = window.URL.createObjectURL(t) : window.webkitURL != null && (e = window.webkitURL.createObjectURL(t)),
    e
}
//# sourceMappingURL=/s/files/1/0497/3065/0278/t/4/assets/uploadImg.js.map?v=71663581520475597171665653463
